import { IApplicationState } from '../../types/redux';
import { selectDictionaries } from './selectDictionaries';

export const selectAvailableRegions = (state: IApplicationState) => selectDictionaries(state).availableRegions;
